import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { EncrDecrService } from '../services/encr-decr.service';

@Injectable({ providedIn: 'root' })
export class LandingPageService {
    loginType = "B2C"; private baseURL: any = ''; private encryptPassword: any = environment.encryptPassword;

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private http: HttpClient, platformLocation: PlatformLocation, private EncrDecr: EncrDecrService) {
        if (isPlatformBrowser(this.platformId)) this.baseURL = (platformLocation as any).location.origin;
    }

    getHomePageData(pgName?) {
        var encryptData = pgName;
        var data = '^&*^&*' + this.baseURL + '^&*merchantSetup';
        let headers = new HttpHeaders(
            {
                'content-type': 'application/json'
            }
        );
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getLocations(str) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = '()' + str + "()()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*locations';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getCruiseLines() {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = "()()()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*cruiselines';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getCruiseAvailability(inputdata, loginType, agentcode, AgentUserLoginId, api) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = inputdata + "()" + this.getloginType() + "()" + agentcode + "()" + AgentUserLoginId + "()" + api + '^&*Get^&*' + this.baseURL + '^&*cruiseavailability';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    checkDest(inputdata) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = inputdata + '^&*Get^&*' + this.baseURL + '^&*isdestination';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getShareItinerary(email, cruise, logindata) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data1 = window.btoa(unescape(encodeURIComponent(email + "()" + cruise + "()" + logindata + "()" + this.getloginType())));
        var data = data1 + '^&*Get^&*' + this.baseURL + '^&*shareitinerary';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getWhatsAppMsg(email, cruise, logindata) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data1 = window.btoa(unescape(encodeURIComponent(email + "()" + cruise + "()" + logindata + "()" + this.getloginType())));
        var data = data1 + '^&*Get^&*' + this.baseURL + '^&*whatsappmsg';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getSailMonths() {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = 'Cruise()()' + "()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*sailmonths';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }
    getCruiseMonths(cruise, methodname) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        //var url = this.baseURL + "/cruiseAPI";
        var data = cruise + "()" + this.getloginType() + '^&*' + methodname + '^&*' + this.baseURL + '^&*cruisecalendaroffer';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getExclusiveDeals() {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = 'Cruise()()' + "()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*cruiseoffers';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getInternationalCruise(cruise, continent, cruiseline) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = cruise + '()' + continent + '()' + cruiseline + "()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*cruiseoffers';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getTravelStoriesCruise(cruise, cruiseline) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = cruise + '()' + cruiseline + "()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*cruiseexternallinks';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getTrendingCruise(cruise, cruiseline) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = cruise + '()' + cruiseline + "()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*cruisetrending';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getCruiseHeading(cruise) {
        let headers = new HttpHeaders(
            { 'content-type': 'application/json' }
        );
        var data = cruise + "()" + this.getloginType() + '^&*Get^&*' + this.baseURL + '^&*cruiseheading';
        var encryptData = this.EncrDecr.set(this.encryptPassword, data);
        return this.http.post(environment.baseUrl, { "searchData": encryptData }, { headers: headers });
    }

    getloginType() {
        if (isPlatformBrowser(this.platformId)) {
            if (!sessionStorage.getItem("loginType")) {
                this.loginType = "B2C";
            } else { this.loginType = sessionStorage.getItem("loginType"); }
        }
        return this.loginType;
    }
}